import React from 'react';
import images from '../../helpers/images';

const Loader = ({ isLoading }) => {

    if (!isLoading) {
        return "";
    }

    return (
        <div style={{ position: 'absolute', zIndex: 99, top: 0, left: 0, bottom: 0, right: 0, background:'rgba(242, 242, 242,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '10px'}}>
            <img src={images.rollin} style={{width: '50px', height: '50px'}}/>
        </div>
    );
}

export default Loader;